
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("7JQiV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $5a254ee6a724e007$var$_jquery = $5a254ee6a724e007$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $5a254ee6a724e007$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5a254ee6a724e007$var$init = module.exports.init = function init() {
    (0, $5a254ee6a724e007$var$_jquery["default"])(".news-list-view,.news-search-result").each(function(index) {
        var $this = (0, $5a254ee6a724e007$var$_jquery["default"])(this);
        var itemsPerPage = $this.attr("data-items-per-page");
        var moreButton = $this.find(".paginate");
        moreButton.on("click", function() {
            var search = ".blog-teaser.d-none:lt(" + itemsPerPage + ")";
            $this.find(search).removeClass("d-none");
            if (!$this.find(".d-none").length > 0) moreButton.hide();
        });
        if (!$this.find(".d-none").length > 0) moreButton.hide();
    });
};

});


//# sourceMappingURL=newsListView.module.15050464.js.map
